/**
 * Whether a request that failed with this status could succeed if repeated.
 *
 * Zero means the request never got an answer at all — a dropped connection,
 * which is the most retriable failure there is. A 4xx means the server looked
 * at the request and refused it on its merits, so repeating it unchanged only
 * produces the same refusal more slowly; 408 and 429 are the exceptions,
 * because both say "not now" rather than "not ever".
 *
 * Shared rather than restated, because the two callers use it for opposite
 * purposes and must not drift: an upload asks "should I try again?", while the
 * survey asks "is this queue stuck until a person does something?" Those are
 * the same question, and a second copy of the rule is a chance for one of them
 * to start answering it differently.
 */
export function isRetriableStatus(status: number): boolean {
  if (status === 0) return true
  if (status === 408 || status === 429) return true
  return status >= 500
}
